import React from "react";
import { Skeleton } from "@mui/material";
import { ProductCard } from "../components/ProductCard";

const ResultsPlaceholder = () => {
    const styles = {
        wrapper: {
            position: "absolute",
            width: "100%",
            height: "100%",
            marginTop: "-30px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            color: "#3e4a5a",
            fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
            maxWidth: "80%",
            margin: "-30px 10% auto 10%",
        },

        content: {
            maxWidth: "520px",
        },

        iconContainer: {
            width: "100px",
            height: "80px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(12px)",
        },

        icon: {
            width: "80px",
            height: "80px",
            stroke: "#0096cd70",
            strokeWidth: 0.8,
            fill: "none",
            strokeLinecap: "round",
        },

        title: {
            margin: "0 0 12px",
            fontSize: "32px",
            fontWeight: "bold",
            color: "#838488ff",
        },

        text: {
            margin: "0 0 8px",
            fontSize: "14px",
            lineHeight: 1.6,
            color: "#838488aa",
        },

        cardsWrapper: {
            position: "relative",
            marginTop: "40px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
        },

        card: {
            position: "absolute",
            top: "10px",
            width: "180px",
            height: "220px",
            borderRadius: "24px",
            background:
                "linear-gradient(to bottom, #ffffff 0%, #f5f7fb 45%, #ffffff 100%)",
            boxShadow: "0 18px 40px rgba(15,23,42,0.14)",
            opacity: 0.9,
            overflow: "hidden",
        },

        wave: {
            position: "absolute",
            inset: "40px 16px 60px",
            borderRadius: "18px",
            background:
                "radial-gradient(circle at 25% 35%, #d4d9e6 0, #e5e9f2 32%, #f6f7fb 70%)",
        },

        dot: {
            position: "absolute",
            top: "72px",
            left: "46px",
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            background: "#ffffff",
            opacity: 0.9,
        },
    };

    // Minimal mock product that satisfies the ProductCard prop shape.
    const mockProduct = {
        id: "placeholder",
        product_data: {
            title: "Product title ...",
            description: "Detailed product description ...",
            price: "0",
            discounted_price: "",
            rating: 4.8,
            source: "Platform",
        },
        images: ["/placeholderimage.png"],
        score: 960,
    };

    return (
        <div style={styles.wrapper}>
            <div style={styles.content}>
                <div style={styles.iconContainer}>
                    <svg viewBox="0 0 24 24" style={styles.icon}>
                        <circle cx="11" cy="11" r="6.5" />
                        <line x1="15.5" y1="15.5" x2="20" y2="20" />
                    </svg>
                </div>

                <h2 style={styles.title}>Your results will appear here</h2>

                <p style={styles.text}>
                    I will show you the best matching products from multiple platforms side by side.
                    You will easily navigate through them to check prices, ratings and key features.
                </p>

                <p style={styles.text}>
                    Buyerry rating will reflect how close the product is to what you have been looking for.
                </p>
            </div>

            <div style={{ ...styles.cardsWrapper, width: '240px' }}>
                {[...Array(3)].map((_, i) => (
                    <div
                        key={i}
                        style={{
                            transform: i === 1 ? "scale(1)" : "scale(0.85)",
                            opacity: i === 1 ? 1 : 0.8,
                            zIndex: i === 1 ? 2 : 1,
                            transition: "all 0.4s ease",
                            marginTop: i === 1 ? "0px" : "10px",
                            marginLeft: i === 2 ? "-40px" : "0px",
                            marginRight: i === 0 ? "-40px" : "0px",
                        }}
                    >
                        <ProductCard
                            product={mockProduct}
                            updateDetail={() => { }}
                            openDetailedPanel={() => { }}
                            selectedView="grid"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ResultsPlaceholder;
